import { useMemo } from 'react';
import { formatDate, parseDateOnly } from '@koob/dates';
import { KoobInputDate } from '@koob/ui/src/components/KoobInputDate';
import { useDays, useTripFilters } from '../../hooks/useTripStoreSelectors';
import { useUpdateTripFilter } from '../../hooks/useUpdateTripFilter';
import { getTripEndDate } from '../../logic/tripFilterOptions';

// Departure date, and the trip's end date it implies.
export default function TripFilterDates() {
  const tripFilters = useTripFilters();
  const days = useDays();
  const updateFilter = useUpdateTripFilter();
  const minDate = useMemo(() => new Date(), []);

  const endDate = getTripEndDate(
    tripFilters?.departureDate,
    tripFilters?.tripDuration,
    days,
  );

  return (
    <>
      <KoobInputDate
        rounded="full"
        value={parseDateOnly(tripFilters?.departureDate)}
        minDate={minDate}
        onChange={(value: unknown) =>
          updateFilter('departureDate', value ?? null)
        }
      />

      <div className="flex h-10 items-center gap-2 rounded-full border border-solid border-gray-200 bg-gray-100 px-4 text-sm font-medium text-gray-600">
        <i className="fa-light fa-calendar text-gray-400" />
        <span>{formatDate(endDate, 'DD/MM/YYYY')}</span>
      </div>
    </>
  );
}
